import { styled } from '@linaria/react';
import { memo } from 'react';
import { locales } from '../../../locales/en';
import { pauseSocketConnection, resumeSocketConnection } from '../../../state/state.app';
import Button from '../../Buttons/Button';
import Dialog from '../../common/Dialog';
import { LoadingScreenCore } from '../LoadingScreen';
import "./DisconnectWarningSnackbar.linaria.module.css!=!./DisconnectWarningSnackbar?./DisconnectWarningSnackbar.linaria.module.css?css=H4sIAAAAAAAAA2WS3W7jIBSE7/cpIq2q7l6QGjdJE/IwCONjjMPfAv6rte++clJnjXthSwPzoYEzexY1/cioEseuOE+FHVCoWWl7krlhN3/4NP/csPuZZdn174/9TLxXFLdNzEM+FdaX4MnsCFbJMvE171TXnWnipNmAelnGmuDD2Q2L4RIojkMvOzWVMjjFRlIpeG4zTbEbe3lU07xMsh3esTbaZV9IivtWBHOcNPNCGrLeVZbi8XCwqtrIybGylEagaB05/E+jIAXgG1DYGK1OmBvFVT+YDjbyySioIsH5ClEpor4hXoo6ZbqO4j8XzsXn1NcyAgqOcSDG9p65xeRZlRUfVKixrzSpbQd+PVJjDczWgC+dK1uzvVU+XytJnaw8Qt2XIgwRMSWFIRxMBH9dv2h2/Zp0lr0s0XJB8eBkxseNnArGb8Lb1pRIaiaAtF79en0LkUXJ3xxTGkUPEFAhkLaFVLDvoXCvv5ejK05xfbJN+7mRU9OGKKsRcWsimLhkXcrlKS7cwd74Rt67hkrpgUdpDeFWtdosmL7ROte6OU3OBnk3eFAsyg4WS50Eeqrp/mJIRtBhk0VZWkUhVZ6qpKjnpKhrO2ztXwM9JzVdE7ctcR/3Oeno2q+2/kcZHsA/HkuRxUUEAAA="
const cancelButtonStyles = "atm_70_lg5vb8 atm_3f_1ujt2s2 atm_j3_mhvnjt atm_9s_1txwivl atm_am_1pywi5l atm_gi_1wugsn5 atm_lo_1y44olf atm_le_1y44olf atm_lk_1fwxnve atm_ll_1fwxnve atm_vv_1q9ccgz atm_raf0b7_glywfm";
const StyledButtonContainer = /*#__PURE__*/styled('div')({
  name: "StyledButtonContainer",
  class: "s19vpdun",
  propsAsIs: false
});
const stylesContainer = "atm_2g_1xpi0cy atm_3f_1ujt2s2 atm_fc_1h6ojuz atm_ar_1bp4okc atm_mk_h2mmj6 atm_h_1h6ojuz atm_9s_1txwivl atm_lo_ftgil2 atm_le_ftgil2 atm_lk_ftgil2 atm_ll_ftgil2";
type Props = {
  paused?: boolean;
};
const DisconnectWarningSnackbar = memo((props: Props) => {
  const {
    paused
  } = props;

  // const [cancelReconenct, setCancel] = useState(false)

  // const onClick = useCallback(() => {
  //     setCancelReconnect({ isCancelled: !cancelReconenct })
  //     if (!cancelReconenct) {
  //         console.log('Attempting to Reconnect')
  //     }
  //     setCancel(!cancelReconenct)
  // }, [cancelReconenct])

  const loadingScreenProp = paused ? {
    progress: false
  } : {
    tagline: 'Reconnecting...'
  };
  return <Dialog open={true} fullWidth maxWidth="xs">
            <div className={stylesContainer}>
                <LoadingScreenCore {...loadingScreenProp} />
                <StyledButtonContainer>
                    <Button title={paused ? locales.system.reconnectAgain : locales.system.cancel} onClick={paused ? resumeSocketConnection : pauseSocketConnection} data-testid="Button__DisconnectWarningSnackbar" size="small" className={cancelButtonStyles}>
                        {paused ? locales.system.reconnectAgain : locales.system.cancel}
                    </Button>
                </StyledButtonContainer>
            </div>
        </Dialog>;
});
export default DisconnectWarningSnackbar;